import type { PortalLanguage } from '@/portal/format';

const ar = {
  loginTitle: 'تسجيل الدخول لحسابك',
  loginSubtitle: 'اطّلع على زياراتك ونتائجك وأرسل طلبات الزيارة المنزلية في مكان واحد.',
  loginIdentity: 'اسم المستخدم أو الكود',
  loginIdentityPlaceholder: 'ادخل اسم المستخدم أو الكود',
  loginPassword: 'كلمة المرور',
  loginShowPassword: 'إظهار كلمة المرور',
  loginHidePassword: 'إخفاء كلمة المرور',
  loginSubmit: 'دخول',
  loginSubmitting: 'جاري الدخول...',
  loginInvalid: 'بيانات الدخول غير صحيحة. تأكد من اسم المستخدم وكلمة المرور.',
  loginNetworkError: 'تعذر الاتصال بالخادم. حاول مرة أخرى بعد قليل.',
  loginNoAccount: 'ليس لديك حساب بعد؟ اطلب تفعيله من أي فرع أو تواصل معنا على واتساب.',
  loginBackHome: 'العودة للموقع',
  loginSecurityNote: 'لا تشارك كلمة المرور مع أي شخص.',
  heroHeadline: 'صحتك في يدك',
  heroBody: 'كل ما يخص تحاليلك في مكان واحد، بخصوصية وأمان.',
  loginHelpButton: 'إزاي أحصل على اسم المستخدم وكلمة المرور؟',
  loginHelpTitle: 'مفيش عندك بيانات دخول؟',
  loginHelpBody: 'الموضوع بسيط: اطلب بياناتك من خلال واتساب وهنرسلها لك في أسرع وقت.',
  loginHelpWhatsapp: 'اطلب بياناتك على واتساب',
  loginHelpMessage: 'مرحبًا، أريد الحصول على اسم المستخدم وكلمة المرور لحسابي على موقع معامل الهامي.',
  loginHelpClose: 'إغلاق',
  heroAfterTitle: 'ماذا ستجد بعد تسجيل الدخول؟',
  heroFeatureResultsTitle: 'نتائج تحاليلك',
  heroFeatureResultsBody: 'شاهد نتيجتك وحمّل ملف PDF في أي وقت، من غير ما تروح الفرع.',
  heroFeatureVisitsTitle: 'سجل زياراتك',
  heroFeatureVisitsBody: 'كل زياراتك السابقة وتفاصيلها وحالة كل زيارة في مكان واحد.',
  heroFeatureHomeTitle: 'طلب زيارة منزلية',
  heroFeatureHomeBody: 'اطلب سحب العينة في بيتك بخطوات بسيطة وتابع طلبك لحظة بلحظة.',
  heroFeaturePointsTitle: 'نقاط ومكافآت',
  heroFeaturePointsBody: 'تابع رصيد نقاطك واستخدمها في زيارتك الجاية.',
  heroFeatureSupportTitle: 'دعم ومتابعة',
  heroFeatureSupportBody: 'تواصل معنا وقدّم شكوى أو استفسار بسهولة.',

  navDashboard: 'الرئيسية',
  navVisits: 'زياراتي',
  navPoints: 'نقاطي',
  quickPointsHint: 'رصيدك وحركة نقاطك',
  pointsTitle: 'نقاطي',
  pointsSubtitle: 'تابع النقاط اللي كسبتها واللي استخدمتها والمتبقي في رصيدك.',
  pointsRemaining: 'الرصيد المتبقي',
  pointsEarned: 'نقاط مكتسبة',
  pointsUsed: 'نقاط مستخدمة',
  pointsUnit: 'نقطة',
  pointsMovements: 'آخر الحركات',
  pointsMovementEarned: 'نقاط من زيارة',
  pointsMovementUsed: 'استخدام نقاط',
  pointsVisitNumber: 'زيارة رقم',
  pointsEmpty: 'لا توجد نقاط مسجلة في حسابك حتى الآن.',
  pointsHeroTitle: 'عندك {points} نقطة جاهزة للاستخدام',
  pointsHeroTitleZero: 'ابدأ تجميع نقاطك',
  pointsHeroBody: 'نقاطك مكافأة على ثقتك فينا. استخدمها في زيارتك الجاية، واسألنا على واتساب نقولك تستفيد بيها إزاي.',
  pointsHeroBodyZero: 'كل زيارة بتزوّد رصيدك، واسألنا على واتساب عن نقاطك في أي وقت.',
  pointsAskWhatsapp: 'اسأل عن نقاطي على واتساب',
  pointsWhatsappMessage: 'مرحباً، أنا {name} (كود العميل {id}). أرغب في الاستعلام عن رصيد نقاطي المتبقي وكيفية استخدامها.',
  pointsChartTitle: 'رصيد نقاطك بنظرة',
  pointsChartHint: 'اختار الشكل اللي يريحك.',
  pointsShapeRing: 'حلقة',
  pointsShapeGauge: 'عدّاد',
  pointsShapeTrend: 'مسار',
  pointsLeftLabel: 'نقطة متبقية',
  pointsPercentAvailable: '{percent}% من نقاطك لسه متاح',
  pointsOfTotal: 'من أصل {total} نقطة',
  pointsTrendNote: 'تطور رصيدك آخر 12 شهر',
  navResults: 'نتائجي',
  navProfile: 'حسابي',
  navHomeVisit: 'زيارة منزلية',
  navLogin: 'تسجيل الدخول',
  navLogout: 'تسجيل الخروج',
  navAccountMenu: 'قائمة الحساب',
  navOpenAccount: 'فتح حسابي',

  greeting: 'أهلاً',
  greetingSeparator: '، ',
  dashboardSubtitle: 'ملخص سريع لحسابك وآخر زيارة.',
  quickVisits: 'زياراتي',
  quickVisitsHint: 'كل زياراتك وتفاصيلها',
  quickResults: 'نتائجي',
  quickResultsHint: 'تحميل تقارير التحاليل',
  quickHomeVisit: 'طلب زيارة منزلية',
  quickHomeVisitHint: 'نجي لحد بيتك',
  quickSupport: 'الدعم والتواصل',
  quickSupportHint: 'تواصل معنا أو زور فروعنا',
  statVisits: 'عدد الزيارات',
  statTests: 'إجمالي التحاليل',
  statRemaining: 'المتبقي للدفع',
  latestVisit: 'آخر زيارة',
  noVisitsYet: 'لا توجد زيارات مسجلة لحسابك حتى الآن.',

  visitsTitle: 'زياراتي',
  visitsSubtitle: 'كل زياراتك مرتبة من الأحدث للأقدم.',
  visitsEmpty: 'لا توجد زيارات لعرضها.',
  visitDay: 'رقم الزيارة',
  testsCount: '{count} تحليل',
  testsCountOne: 'تحليل واحد',
  viewDetails: 'التفاصيل',

  visitDetailsTitle: 'تفاصيل الزيارة',
  visitDetailsSubtitle: 'التحاليل المطلوبة والحساب المالي لهذه الزيارة.',
  visitTests: 'التحاليل',
  visitDoctor: 'الطبيب',
  visitDoctorNone: 'غير مسجل',
  visitNoTests: 'لا توجد تحاليل مسجلة لهذه الزيارة.',
  paymentTitle: 'التفاصيل المالية',
  paymentTotal: 'الإجمالي',
  paymentDiscount: 'الخصم',
  paymentPaid: 'المدفوع',
  paymentRemaining: 'المتبقي',
  paymentSettled: 'تم السداد بالكامل',
  reportDownload: 'تحميل النتيجة',
  reportLockedUnpaid: 'يمكنك تحميل النتيجة بعد سداد المبلغ المتبقي.',
  reportLoading: 'جاري تحضير التقرير...',
  reportUnavailable: 'التقرير غير متاح حالياً. سيظهر هنا فور جاهزيته.',
  backToVisits: 'الرجوع لزياراتي',

  resultsTitle: 'نتائجي',
  resultsSubtitle: 'حمّل تقرير كل زيارة بصيغة PDF.',
  resultsEmpty: 'لا توجد نتائج متاحة بعد.',
  resultsHint: 'إذا لم يظهر التقرير بعد، فغالباً لم تكتمل التحاليل.',

  profileTitle: 'حسابي',
  profileSubtitle: 'بيانات حسابك وإعداداتك.',
  profileName: 'الاسم',
  profilePhone: 'رقم الهاتف',
  homeVisitPrefilled: 'تم تعبئة بياناتك من حسابك. اكتب التحاليل وارفع الروشتة واختر الموعد فقط.',
  homeVisitAddressHint: 'عنوانك المسجل ظاهر هنا. عدّله أو أضف تفاصيل أكثر (الدور، الشقة، علامة مميزة).',
  profileUsername: 'اسم المستخدم',
  profileCustomerId: 'كود العميل',
  profileLanguage: 'لغة الموقع',
  profileSupport: 'تحتاج مساعدة؟',
  profileSupportBody: 'فريق الدعم متاح للرد على استفساراتك.',
  profileContact: 'تواصل معنا',

  stateLoading: 'جاري التحميل...',
  stateErrorTitle: 'حدث خطأ أثناء تحميل البيانات',
  stateRetry: 'إعادة المحاولة',
  sessionExpired: 'انتهت جلستك. سجّل الدخول مرة أخرى.',
  notFoundVisit: 'الزيارة غير موجودة في حسابك.',
  navComplaints: 'الشكاوى',
  quickComplaintsHint: 'أرسل ملاحظتك لفريقنا',
  complaintsTitle: 'الشكاوى والملاحظات',
  complaintsSubtitle: 'أرسل لنا ملاحظتك وسنتابعها مع الفريق المختص.',
  complaintsEmpty: 'لا توجد شكاوى مسجلة على حسابك.',
  complaintsNew: 'شكوى جديدة',
  complaintBody: 'تفاصيل الشكوى',
  complaintBodyPlaceholder: 'اكتب ما حدث بالتفصيل',
  complaintEmail: 'البريد الإلكتروني',
  complaintPhone: 'رقم الموبايل',
  complaintSubmit: 'إرسال الشكوى',
  complaintSubmitting: 'جاري الإرسال...',
  complaintSent: 'تم إرسال الشكوى بنجاح. سنتواصل معك قريباً.',
  complaintHandled: 'تمت المتابعة',
  complaintOpen: 'قيد المراجعة',
  complaintDate: 'تاريخ الإرسال',
  passwordTitle: 'تغيير كلمة المرور',
  passwordSubtitle: 'اختر كلمة مرور جديدة لا تقل عن 6 أحرف.',
  passwordCurrent: 'كلمة المرور الحالية',
  passwordNew: 'كلمة المرور الجديدة',
  passwordConfirm: 'تأكيد كلمة المرور الجديدة',
  passwordSave: 'حفظ كلمة المرور',
  passwordSaving: 'جاري الحفظ...',
  passwordChanged: 'تم تغيير كلمة المرور بنجاح.',
  errCurrentRequired: 'اكتب كلمة المرور الحالية.',
  errPasswordLength: 'كلمة المرور الجديدة لازم تكون من 6 لـ 64 حرف.',
  errPasswordSame: 'كلمة المرور الجديدة لازم تختلف عن الحالية.',
  errPasswordMismatch: 'تأكيد كلمة المرور مش مطابق.',
  errCurrentIncorrect: 'كلمة المرور الحالية غير صحيحة.',
  errComplaintRequired: 'اكتب تفاصيل الشكوى.',
  errComplaintTooLong: 'الشكوى أطول من المسموح (2000 حرف).',
  errEmailInvalid: 'البريد الإلكتروني غير صحيح.',
  errPhoneInvalid: 'رقم الموبايل غير صحيح.',
  errGeneric: 'حدث خطأ. حاول مرة أخرى.',
  loginDoctorNote: 'هل أنت طبيب؟ ادخل من نفس الصفحة وهتفتح لك لوحة الطبيب تلقائيًا.',
  drBadge: 'طبيب',
  drNavOverview: 'نظرة عامة',
  drNavResults: 'نتائج المرضى',
  drNavSettings: 'الحساب والإعدادات',
  drGreeting: 'أهلاً دكتور',
  drOverviewSubtitle: 'ملخص نشاطك ومرضاك الأخيرين في مكان واحد.',
  drStatToday: 'مرضى اليوم',
  drStatWeek: 'آخر 7 أيام',
  drStatTotal: 'إجمالي المرضى',
  drStatAverage: 'المتوسط في اليوم النشط',
  drStatBusiest: 'أكثر الأيام ازدحامًا',
  drTrendTitle: 'مرضاك في آخر 14 يومًا',
  drTrendHint: 'عدد المرضى الذين أحلتهم إلينا كل يوم.',
  drRecentTitle: 'آخر المرضى',
  drViewAll: 'عرض كل النتائج',
  drNoPatients: 'لا يوجد مرضى مسجلون باسمك حتى الآن.',
  drPatientsCount: '{count} مريض',
  drPatientsCountOne: 'مريض واحد',
  drResultsTitle: 'نتائج المرضى',
  drResultsSubtitle: 'ابحث عن مريضك وافتح نتيجته أو حمّلها بصيغة PDF.',
  drSearchPlaceholder: 'ابحث باسم المريض أو رقم الزيارة',
  drRangeToday: 'اليوم',
  drRangeWeek: 'آخر 7 أيام',
  drRangeAll: 'الكل',
  drNoMatches: 'لا توجد نتائج مطابقة لبحثك.',
  drVisitId: 'رقم الزيارة',
  drViewResult: 'عرض النتيجة',
  drDownloadResult: 'تحميل PDF',
  drDownloading: 'جاري التحميل...',
  drCopyId: 'نسخ رقم الزيارة',
  drCopied: 'تم النسخ',
  drResultUnavailable: 'النتيجة غير جاهزة بعد. حاول لاحقًا.',
  resultRequestButton: 'طلب النتيجة',
  resultRequestSending: 'جاري الإرسال...',
  resultRequestSent: 'تم إرسال طلب النتيجة، وستظهر هنا فور رفعها.',
  resultRequestPayFirst: 'سدّد المبلغ المتبقي أولاً ثم اطلب النتيجة.',
  resultRequestHint: 'النتيجة لم تُرفع بعد. اضغط لطلبها من المعمل.',
  resultRequestFailed: 'تعذر إرسال الطلب. حاول مرة أخرى.',
  drSettingsTitle: 'الحساب والإعدادات',
  drSettingsSubtitle: 'بياناتك وكلمة المرور وإدارة الحساب.',
  drProfileName: 'الاسم',
  drProfileCode: 'كود الطبيب',
  drProfileUsername: 'اسم المستخدم',
  deleteTitle: 'حذف الحساب',
  deleteBody: 'حذف الحساب بيقفل الدخول عليه نهائياً. اكتب كلمة المرور للتأكيد.',
  deleteSubmit: 'حذف حسابي',
  deleteSubmitting: 'جاري الحذف...',
  deleteDone: 'تم حذف حسابك.',
} as const;

export type PortalTextKey = keyof typeof ar;

const en: Record<PortalTextKey, string> = {
  loginTitle: 'Sign in to your account',
  loginSubtitle: 'View your visits and results and request a home visit in one place.',
  loginIdentity: 'Username or code',
  loginIdentityPlaceholder: 'Enter your username or code',
  loginPassword: 'Password',
  loginShowPassword: 'Show password',
  loginHidePassword: 'Hide password',
  loginSubmit: 'Sign in',
  loginSubmitting: 'Signing in...',
  loginInvalid: 'Invalid credentials. Check your username and password.',
  loginNetworkError: 'Could not reach the server. Please try again shortly.',
  loginNoAccount: "Don't have an account yet? Ask any branch to activate it or message us on WhatsApp.",
  loginBackHome: 'Back to website',
  loginSecurityNote: 'Never share your password with anyone.',
  heroHeadline: 'Your health, in your hands',
  heroBody: 'Everything about your tests in one place, private and secure.',
  loginHelpButton: 'How do I get my username and password?',
  loginHelpTitle: "Don't have your credentials?",
  loginHelpBody: "It's simple: ask us on WhatsApp and we will send you your credentials.",
  loginHelpWhatsapp: 'Ask for your credentials on WhatsApp',
  loginHelpMessage: 'Hello, I would like to get the username and password for my Elhamy Labs account.',
  loginHelpClose: 'Close',
  heroAfterTitle: 'What you get after signing in',
  heroFeatureResultsTitle: 'Your test results',
  heroFeatureResultsBody: 'View your results and download the PDF any time, without visiting a branch.',
  heroFeatureVisitsTitle: 'Visit history',
  heroFeatureVisitsBody: 'All your past visits, their details and status in one place.',
  heroFeatureHomeTitle: 'Home visit requests',
  heroFeatureHomeBody: 'Request a sample collection at home in a few steps and follow your request.',
  heroFeaturePointsTitle: 'Points and rewards',
  heroFeaturePointsBody: 'Track your points balance and use it on your next visit.',
  heroFeatureSupportTitle: 'Support',
  heroFeatureSupportBody: 'Contact us and send a complaint or question easily.',

  navDashboard: 'Home',
  navVisits: 'My visits',
  navPoints: 'My points',
  quickPointsHint: 'Your balance and point history',
  pointsTitle: 'My points',
  pointsSubtitle: 'Follow the points you earned, the ones you used and what is left in your balance.',
  pointsRemaining: 'Remaining balance',
  pointsEarned: 'Points earned',
  pointsUsed: 'Points used',
  pointsUnit: 'pts',
  pointsMovements: 'Recent activity',
  pointsMovementEarned: 'Earned from a visit',
  pointsMovementUsed: 'Points redeemed',
  pointsVisitNumber: 'Visit no.',
  pointsEmpty: 'No points are recorded on your account yet.',
  pointsHeroTitle: 'You have {points} points ready to use',
  pointsHeroTitleZero: 'Start collecting your points',
  pointsHeroBody: 'Your points are a thank-you for trusting us. Use them on your next visit, and ask us on WhatsApp how to get the most out of them.',
  pointsHeroBodyZero: 'Every visit adds to your balance, and you can ask us about your points on WhatsApp any time.',
  pointsAskWhatsapp: 'Ask about my points on WhatsApp',
  pointsWhatsappMessage: 'Hello, I am {name} (customer code {id}). I would like to know my remaining points balance and how to use it.',
  pointsChartTitle: 'Your points at a glance',
  pointsChartHint: 'Pick the view you like best.',
  pointsShapeRing: 'Ring',
  pointsShapeGauge: 'Gauge',
  pointsShapeTrend: 'Trend',
  pointsLeftLabel: 'points left',
  pointsPercentAvailable: '{percent}% of your points are still available',
  pointsOfTotal: 'out of {total} points',
  pointsTrendNote: 'Your balance over the last 12 months',
  navResults: 'My results',
  navProfile: 'My account',
  navHomeVisit: 'Home visit',
  navLogin: 'Sign in',
  navLogout: 'Sign out',
  navAccountMenu: 'Account menu',
  navOpenAccount: 'Open my account',

  greeting: 'Welcome',
  greetingSeparator: ', ',
  dashboardSubtitle: 'A quick overview of your account and latest visit.',
  quickVisits: 'My visits',
  quickVisitsHint: 'All your visits and their details',
  quickResults: 'My results',
  quickResultsHint: 'Download your lab reports',
  quickHomeVisit: 'Request a home visit',
  quickHomeVisitHint: 'We come to your home',
  quickSupport: 'Support',
  quickSupportHint: 'Contact us or visit a branch',
  statVisits: 'Visits',
  statTests: 'Total tests',
  statRemaining: 'Amount due',
  latestVisit: 'Latest visit',
  noVisitsYet: 'No visits are recorded for your account yet.',

  visitsTitle: 'My visits',
  visitsSubtitle: 'All your visits, newest first.',
  visitsEmpty: 'No visits to show.',
  visitDay: 'Visit number',
  testsCount: '{count} tests',
  testsCountOne: '1 test',
  viewDetails: 'Details',

  visitDetailsTitle: 'Visit details',
  visitDetailsSubtitle: 'The tests and payment summary for this visit.',
  visitTests: 'Tests',
  visitDoctor: 'Doctor',
  visitDoctorNone: 'Not recorded',
  visitNoTests: 'No tests are recorded for this visit.',
  paymentTitle: 'Payment details',
  paymentTotal: 'Total',
  paymentDiscount: 'Discount',
  paymentPaid: 'Paid',
  paymentRemaining: 'Remaining',
  paymentSettled: 'Fully paid',
  reportDownload: 'Download result',
  reportLockedUnpaid: 'You can download your result once the remaining balance is paid.',
  reportLoading: 'Preparing your report...',
  reportUnavailable: 'The report is not available yet. It will appear here once it is ready.',
  backToVisits: 'Back to my visits',

  resultsTitle: 'My results',
  resultsSubtitle: 'Download the report for each visit as a PDF.',
  resultsEmpty: 'No results are available yet.',
  resultsHint: 'If a report is missing, its tests are probably not finished yet.',

  profileTitle: 'My account',
  profileSubtitle: 'Your account details and settings.',
  profileName: 'Name',
  profilePhone: 'Phone number',
  homeVisitPrefilled: 'Your details were filled in from your account. Just add the tests, a prescription photo and a date and time.',
  homeVisitAddressHint: 'Your saved address is shown here. Edit it or add more details (floor, apartment, landmark).',
  profileUsername: 'Username',
  profileCustomerId: 'Customer code',
  profileLanguage: 'Website language',
  profileSupport: 'Need help?',
  profileSupportBody: 'Our support team is ready to answer your questions.',
  profileContact: 'Contact us',

  stateLoading: 'Loading...',
  stateErrorTitle: 'Something went wrong while loading your data',
  stateRetry: 'Try again',
  sessionExpired: 'Your session has ended. Please sign in again.',
  notFoundVisit: 'This visit is not in your account.',
  deleteTitle: 'Delete account',
  deleteBody: 'Deleting your account permanently locks you out. Enter your password to confirm.',
  deleteSubmit: 'Delete my account',
  deleteSubmitting: 'Deleting...',
  deleteDone: 'Your account was deleted.',
  navComplaints: 'Complaints',
  quickComplaintsHint: 'Send feedback to our team',
  complaintsTitle: 'Complaints and feedback',
  complaintsSubtitle: 'Send us your feedback and our team will follow up.',
  complaintsEmpty: 'You have no complaints on your account.',
  complaintsNew: 'New complaint',
  complaintBody: 'Complaint details',
  complaintBodyPlaceholder: 'Describe what happened',
  complaintEmail: 'Email',
  complaintPhone: 'Mobile number',
  complaintSubmit: 'Send complaint',
  complaintSubmitting: 'Sending...',
  complaintSent: 'Your complaint was sent. We will contact you soon.',
  complaintHandled: 'Followed up',
  complaintOpen: 'Under review',
  complaintDate: 'Sent on',
  passwordTitle: 'Change password',
  passwordSubtitle: 'Choose a new password of at least 6 characters.',
  passwordCurrent: 'Current password',
  passwordNew: 'New password',
  passwordConfirm: 'Confirm new password',
  passwordSave: 'Save password',
  passwordSaving: 'Saving...',
  passwordChanged: 'Your password was changed.',
  errCurrentRequired: 'Enter your current password.',
  errPasswordLength: 'The new password must be 6 to 64 characters.',
  errPasswordSame: 'The new password must differ from the current one.',
  errPasswordMismatch: 'The password confirmation does not match.',
  errCurrentIncorrect: 'The current password is incorrect.',
  errComplaintRequired: 'Describe the complaint.',
  errComplaintTooLong: 'The complaint is longer than 2000 characters.',
  errEmailInvalid: 'Enter a valid email address.',
  errPhoneInvalid: 'Enter a valid mobile number.',
  errGeneric: 'Something went wrong. Please try again.',
  loginDoctorNote: 'Are you a doctor? Sign in here and the doctor dashboard opens automatically.',
  drBadge: 'Doctor',
  drNavOverview: 'Overview',
  drNavResults: 'Patient results',
  drNavSettings: 'Account & settings',
  drGreeting: 'Welcome, Dr.',
  drOverviewSubtitle: 'Your activity and latest patients in one place.',
  drStatToday: 'Patients today',
  drStatWeek: 'Last 7 days',
  drStatTotal: 'Total patients',
  drStatAverage: 'Average per active day',
  drStatBusiest: 'Busiest day',
  drTrendTitle: 'Your patients, last 14 days',
  drTrendHint: 'How many patients you referred to us each day.',
  drRecentTitle: 'Latest patients',
  drViewAll: 'View all results',
  drNoPatients: 'No patients are recorded under your name yet.',
  drPatientsCount: '{count} patients',
  drPatientsCountOne: '1 patient',
  drResultsTitle: 'Patient results',
  drResultsSubtitle: 'Find your patient, then open the result or download it as a PDF.',
  drSearchPlaceholder: 'Search by patient name or visit number',
  drRangeToday: 'Today',
  drRangeWeek: 'Last 7 days',
  drRangeAll: 'All',
  drNoMatches: 'Nothing matches your search.',
  drVisitId: 'Visit number',
  drViewResult: 'View result',
  drDownloadResult: 'Download PDF',
  drDownloading: 'Downloading...',
  drCopyId: 'Copy visit number',
  drCopied: 'Copied',
  drResultUnavailable: 'The result is not ready yet. Please try later.',
  resultRequestButton: 'Request result',
  resultRequestSending: 'Sending...',
  resultRequestSent: 'Result request sent. It will appear here as soon as it is uploaded.',
  resultRequestPayFirst: 'Please pay the remaining balance first, then request the result.',
  resultRequestHint: 'The result has not been uploaded yet. Tap to request it from the lab.',
  resultRequestFailed: 'Could not send the request. Please try again.',
  drSettingsTitle: 'Account & settings',
  drSettingsSubtitle: 'Your details, password and account management.',
  drProfileName: 'Name',
  drProfileCode: 'Doctor code',
  drProfileUsername: 'Username',
};

export const portalText: Record<PortalLanguage, Record<PortalTextKey, string>> = { ar, en };
